import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

function ChangePasswordModal({ show, onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('Preencha todos os campos.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Nova senha e confirmação não conferem.');
      return;
    }
    const complexityRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/;
    if (newPassword.length < 8 || !complexityRegex.test(newPassword)) {
      setError('A nova senha deve ter ao menos 8 caracteres, incluir letras, números e símbolos.');
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_BASE_URL.USUARIO}/change-password`,
        { currentPassword, newPassword, confirmPassword },
        { headers: { Authorization: token ? `Bearer ${token}` : undefined } }
      );
      setError('Senha alterada com sucesso.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(() => {
        setError('');
        onClose();
      }, 1000);
    } catch (err) {
      const msg = err?.response?.data || 'Erro ao alterar senha.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog modal-sm">
        <div className="modal-content" style={{ borderRadius: '0.5rem', overflow: 'hidden' }}>
          <div className="modal-header text-white" style={{ background: 'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
              padding: '0.35rem 0.75rem',
              border: 'none',
              flexShrink: 0 }}>
            <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
              <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}><i className="bi bi-key me-2"></i>Alterar senha</h6>
              <div className="d-flex align-items-center gap-2">
                <button className="btn btn-link text-white p-0 mb-0" onClick={onClose} title="Fechar" style={{ fontSize: '1rem', textDecoration: 'none' }}><i className="bi bi-x-lg"></i></button>
              </div>
            </div>
          </div>
          <div className="modal-body">
            <form id="change-password-form" onSubmit={handleSubmit}>
              <div className="mb-2">
                <label className="form-label small">Senha atual</label>
                <input type="password" className="form-control form-control-sm" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} />
              </div>
              <div className="mb-2">
                <label className="form-label small">Nova senha</label>
                <input type="password" className="form-control form-control-sm" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
              </div>
              <div className="mb-2">
                <label className="form-label small">Confirmar nova senha</label>
                <input type="password" className="form-control form-control-sm" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
              </div>
              {error && <div className="alert alert-danger small py-2">{error}</div>}
            </form>
          </div>
          <div className="modal-footer" style={{ padding: '0.35rem 1rem' }}>
            <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancelar</button>
            <button type="submit" form="change-password-form" className="btn btn-success btn-sm" disabled={loading}>{loading ? 'Alterando...' : 'Alterar'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordModal;
